import { Toolbar, AppBar, Container } from "@mui/material";
import Title from "./Title";
import NavigationMenu from "./NavigationMenu";
import { Pages } from "../../types/utils";
import useIsMobileView from "../../utils/hooks/useIsMobileView";

const Header = () => {
  const IsMobileView = useIsMobileView();
  return (
    <AppBar position="static" sx={style.appbar}>
      <Container disableGutters maxWidth="lg">
        <Toolbar
          disableGutters
          variant="dense"
          sx={{
            my: "2%",
            flexDirection: IsMobileView ? "row-reverse" : "row",
            justifyContent: IsMobileView ? "center" : "space-between",
            padding: "0px 0px 0px 0px",
          }}
        >
          <Container
            disableGutters
            sx={{
              width: IsMobileView ? "90%" : "none",
            }}
          >
            <Title text="DÜSARTRILISE KÕNE ARUSAADAVUSE TEST" />
          </Container>
          <Container
            disableGutters
            sx={{
              width: IsMobileView ? "10%" : "none",
            }}
          >
            <NavigationMenu links={pages} />
          </Container>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;

const style = {
  appbar: {
    backgroundColor: "transparent",
    boxShadow: "0px 0px 0px 0px",
    padding: "0px 0px 0px 0px",
  },
};

const pages: Pages = {
  Avaleht: "/",
  Proovitest: "/proovitest",
  Test: "/testialgus",
  KKK: "/kkk",
  Lisainfo: "/rohkeminfot",
  Kontakt: "/kontakt",
};
